// Light Theme
export const colors = {
  primary: '#0057B8',        // Katip blue
  primaryLight: '#E3F2FD',   // Light blue background
  secondary: '#FFC107',      // Accent yellow
  background: '#FFFFFF',     // White background
  surface: '#F4F6F8',        // Light gray surface
  textPrimary: '#212121',    // Dark gray text
  textSecondary: '#757575',  // Medium gray text
  border: '#E0E0E0',         // Light border
  error: '#D32F2F',          // Error red
  success: '#388E3C',        // Success green
  warning: '#F57C00',        // Warning orange
  accent: '#00BFAE'          // Accent teal
};

// Dark Theme
export const colorsDark = {
  primary: '#1976D2',
  background: '#181A1B',
  surface: '#23272A',
  textPrimary: '#FFFFFF',
  textSecondary: '#B0B0B0',
  border: '#404040'
};

// Typography
export const fontSizes = {
  h1: 28,
  h2: 24,
  h3: 20,
  h4: 18,
  body: 16,
  button: 16,
  caption: 14,
  small: 12
};

export const fontWeights = {
  light: '300',
  regular: '400',
  medium: '500',
  bold: '700'
}; 